export const getLocalStorageJson = (key: string) => {
  const item = localStorage.getItem(key);
  if (!item) return null;
  try {
    return JSON.parse(item);
  } catch (error) {
    console.error(`Error parsing localStorage item "${key}":`, error);
    return item;
  }
};

export const setLocalStorageJson = (key: string, value: unknown) => {
  localStorage.setItem(key, JSON.stringify(value));
};
